/* Bisou 2.0 — PDP additions: bundle & save selector, sticky add-to-cart bar, cart remove */
(function () {
  function formatMoney(cents, sample) {
    var value = Math.round(cents / 100);
    var str = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (sample && /kr/i.test(sample)) return str + ' kr';
    if (sample && /^\D/.test(sample)) return sample.replace(/[\d\s.,]+/, str);
    return str + ' kr';
  }

  class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.mainProduct = this.closest('main-product');
      this.inputs = Array.from(this.querySelectorAll('input[name="bundle-option"]'));
      this.addEventListener('change', this.onChange.bind(this));
      var checked = this.querySelector('input[name="bundle-option"]:checked');
      if (checked) this.apply(checked);
    }

    onChange(e) {
      if (e.target.name !== 'bundle-option') return;
      this.apply(e.target);
    }

    apply(input) {
      this.inputs.forEach(function (i) {
        i.closest('.main-product__bundle-option').classList.toggle('is-selected', i === input);
      });
      var qty = parseInt(input.value, 10) || 1;
      var total = parseInt(input.dataset.total, 10);
      var root = this.mainProduct || document;
      var qtyInput = root.querySelector('[name="quantity"]');
      if (qtyInput) qtyInput.value = qty;

      var sample = (root.querySelector('.main-product__price-main') || {}).textContent || '';
      var money = formatMoney(total, sample.trim());
      root.querySelectorAll('[data-cta-price], [data-sticky-price]').forEach(function (el) { el.textContent = money; });
      var meta = root.querySelector('[data-sticky-meta]');
      if (meta) meta.textContent = input.closest('.main-product__bundle-option').querySelector('.main-product__bundle-label').firstChild.textContent.trim() + ' · ' + money;
    }
  }
  if (!customElements.get('bundle-selector')) customElements.define('bundle-selector', BundleSelector);

  /* Sticky bar */
  function initSticky() {
    var mainProduct = document.querySelector('main-product');
    var bar = document.querySelector('[data-sticky-bar]');
    var trigger = document.querySelector('[data-add-button]');
    if (!mainProduct || !bar || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      document.documentElement.classList.toggle('has-sticky-bar', passed);
    }, { threshold: 0 });
    observer.observe(trigger);

    bar.addEventListener('click', function (e) {
      if (e.target.dataset.action !== 'sticky-add') return;
      if (typeof mainProduct.onFormSubmit === 'function') {
        mainProduct.onFormSubmit();
      } else {
        trigger.click();
      }
    });
  }

  /* Cart drawer: remove line (quantity 0) — extends the theme's CartDrawer */
  function initCartRemove() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="remove-item"]');
      if (!btn) return;
      e.preventDefault();
      var drawer = btn.closest('cart-drawer');
      var item = btn.closest('[data-item]');
      if (!drawer || !item || typeof drawer.updateQuantity !== 'function') return;
      if (drawer.isLoading) return;
      drawer.updateQuantity(parseInt(item.dataset.item, 10), 0, item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSticky(); initCartRemove(); });
  } else {
    initSticky(); initCartRemove();
  }
})();
